import { AmbientLight, Scene, SpotLight, SpotLightHelper, Vector3 } from "three";
import { ScenesManager } from "./ScenesManager";
import gsap from "gsap";
import { IFeatureLight } from "data/features";

export class EnvironmentManager {
  static featureLight: SpotLight;
  static featureLightTween: gsap.core.Tween;
  static featureLightHelper: SpotLightHelper;
  static featureLightDefaults = {
    intensity: 0,
    distance: 11,
    angle: 0.239,
    penumbra: 0.413,
    decay: 0.47,
  };
  static ambientLight: AmbientLight;

  static setup(scene: Scene) {
    EnvironmentManager.featureLight = new SpotLight(0xcccccc, 
      EnvironmentManager.featureLightDefaults.intensity,
      EnvironmentManager.featureLightDefaults.distance,
      EnvironmentManager.featureLightDefaults.angle,
      EnvironmentManager.featureLightDefaults.penumbra,
      EnvironmentManager.featureLightDefaults.decay,
    )
    EnvironmentManager.featureLight.position.set(3.6144185066223145, -0.49572951793670655, 1.2758787870407104);
    scene.add(EnvironmentManager.featureLight);
    EnvironmentManager.ambientLight = new AmbientLight(0xffffff, .15)
    scene.add(EnvironmentManager.ambientLight);
  }

  static updateFeatureLight(settings: IFeatureLight) {
    EnvironmentManager.featureLightTween?.kill();
    EnvironmentManager.featureLight.position.copy(settings.lookAt.clone().add(ScenesManager.mainScene.camera.position));
    EnvironmentManager.featureLight.lookAt(settings.lookAt);
    EnvironmentManager.featureLightTween = gsap.to(EnvironmentManager.featureLight, {
      intensity: settings.intensity,
      distance: settings.distance ? settings.distance : EnvironmentManager.featureLightDefaults.distance,
      angle: settings.angle ? settings.angle : EnvironmentManager.featureLightDefaults.angle,
      decay: settings.decay ? settings.decay : EnvironmentManager.featureLightDefaults.decay,
      penumbra: settings.penumbra ? settings.penumbra : EnvironmentManager.featureLightDefaults.penumbra,
      duration: 1.4,
      delay: 0.4,
      easing: 'power2.easeInOut'
    })

  }

  static hideFeatureLight() {
    EnvironmentManager.featureLightTween?.kill();
    EnvironmentManager.featureLightTween = gsap.to(EnvironmentManager.featureLight, {
      intensity: 0,
      duration: 0.3,
      easing: 'quad.easeOut'
    })
  }

  static update() {
    EnvironmentManager.featureLightHelper?.update();
  }

  static dispose() {
    
  }
}
